import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { SharedDataService } from  './shared-data.service';

@Injectable()
export class AuthenticationService {

  constructor(private router: Router, public sharedDataService: SharedDataService) { }

  canActivate(){
      const auth  = this.sharedDataService;
      
  }

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/authentication.service.ts